/**
 * Ad Broadcast Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { AutoScout24ReferenceTypes } from '../model/autoScout24ReferenceTypes';
import { BusinessBroadcastConnectionConfigurationDto } from '../model/businessBroadcastConnectionConfigurationDto';
import { BusinessBroadcastConnectionConfigurationListItemDto } from '../model/businessBroadcastConnectionConfigurationListItemDto';
import { CountryBroadcastConnectionConfigurationDto } from '../model/countryBroadcastConnectionConfigurationDto';
import { CountryBroadcastConnectionConfigurationListItemDto } from '../model/countryBroadcastConnectionConfigurationListItemDto';
import { CountryBroadcastConnectionConfigurationMappingsListItemDto } from '../model/countryBroadcastConnectionConfigurationMappingsListItemDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { MakeAndModelDto } from '../model/makeAndModelDto';
import { AutoScout24ReferenceType } from '../model/autoScout24ReferenceType';
import { MobileReferenceTypes } from '../model/mobileReferenceTypes';
import { MobileReferenceType } from '../model/mobileReferenceType';


@Injectable()
export class BroadcastConnectionConfigurationViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    
    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/AutoscoutReference AmsResource:{country}/_* 
     * @param referenceType 
     * @param country 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public autoscoutReference(referenceType?: string, country?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AutoScout24ReferenceType>>;
    public autoscoutReference(referenceType?: string, country?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AutoScout24ReferenceType>>>;
    public autoscoutReference(referenceType?: string, country?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AutoScout24ReferenceType>>>;
    public autoscoutReference(referenceType?: string, country?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (referenceType !== undefined && referenceType !== null) {
          queryParameters = queryParameters.set('referenceType', <any>referenceType);
        }
        if (country !== undefined && country !== null) {
          queryParameters = queryParameters.set('country', <any>country);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AutoScout24ReferenceTypes>(`${this.basePath}/api/BroadcastConnectionConfigurationView/AutoscoutReference`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/MobileReference AmsResource:{country}/_* 
     * @param referenceType 
     * @param country 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mobileReference(referenceType?: string, country?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MobileReferenceType>>;
    public mobileReference(referenceType?: string, country?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MobileReferenceType>>>;
    public mobileReference(referenceType?: string, country?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MobileReferenceType>>>;
    public mobileReference(referenceType?: string, country?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (referenceType !== undefined && referenceType !== null) {
          queryParameters = queryParameters.set('referenceType', <any>referenceType);
        }
        if (country !== undefined && country !== null) {
          queryParameters = queryParameters.set('country', <any>country);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MobileReferenceTypes>(`${this.basePath}/api/BroadcastConnectionConfigurationView/MobileReference`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/MobileClassReference AmsResource:{country}/_* 
     * @param referenceType 
     * @param country 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mobileClassReference(referenceType?: string, country?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MobileReferenceType>>;
    public mobileClassReference(referenceType?: string, country?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (referenceType !== undefined && referenceType !== null) {
          queryParameters = queryParameters.set('referenceType', <any>referenceType);
        }
        if (country !== undefined && country !== null) {
          queryParameters = queryParameters.set('country', <any>country);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MobileReferenceTypes>(`${this.basePath}/api/BroadcastConnectionConfigurationView/MobileClassReference`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/AutoscoutMakesAndModels AmsResource:{country}/_* 
     * @param market 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public autoscoutMakesAndModels(market?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MakeAndModelDto>>;
    public autoscoutMakesAndModels(market?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MakeAndModelDto>>>;
    public autoscoutMakesAndModels(market?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MakeAndModelDto>>>;
    public autoscoutMakesAndModels(market?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (market !== undefined && market !== null) {
          queryParameters = queryParameters.set('market', <any>market);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MakeAndModelDto>>(`${this.basePath}/api/BroadcastConnectionConfigurationView/AutoscoutMakesAndModels`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveJobs(observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getActiveJobs(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getActiveJobs(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getActiveJobs(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Blob>(`${this.basePath}/api/BroadcastConnectionConfigurationView/jobs`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/{broadcastConnectionConfigurationId}/country/{countryId} AmsResource:{country}/_* 
     * @param broadcastConnectionConfigurationId 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCountryBroadcastConnectionConfiguration(broadcastConnectionConfigurationId: string, countryId: string, observe?: 'body', reportProgress?: boolean): Observable<CountryBroadcastConnectionConfigurationDto>;
    public getCountryBroadcastConnectionConfiguration(broadcastConnectionConfigurationId: string, countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CountryBroadcastConnectionConfigurationDto>>;
    public getCountryBroadcastConnectionConfiguration(broadcastConnectionConfigurationId: string, countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CountryBroadcastConnectionConfigurationDto>>;
    public getCountryBroadcastConnectionConfiguration(broadcastConnectionConfigurationId: string, countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (broadcastConnectionConfigurationId === null || broadcastConnectionConfigurationId === undefined) {
            throw new Error('Required parameter broadcastConnectionConfigurationId was null or undefined when calling getCountryBroadcastConnectionConfiguration.');
        }

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling getCountryBroadcastConnectionConfiguration.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CountryBroadcastConnectionConfigurationDto>(`${this.basePath}/api/BroadcastConnectionConfigurationView/${encodeURIComponent(String(broadcastConnectionConfigurationId))}/country/${encodeURIComponent(String(countryId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param broadcastConnectionConfigurationId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCountryBroadcastConnectionConfigurationCertificate(broadcastConnectionConfigurationId: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getCountryBroadcastConnectionConfigurationCertificate(broadcastConnectionConfigurationId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getCountryBroadcastConnectionConfigurationCertificate(broadcastConnectionConfigurationId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getCountryBroadcastConnectionConfigurationCertificate(broadcastConnectionConfigurationId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (broadcastConnectionConfigurationId === null || broadcastConnectionConfigurationId === undefined) {
            throw new Error('Required parameter broadcastConnectionConfigurationId was null or undefined when calling getCountryBroadcastConnectionConfigurationCertificate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Blob>(`${this.basePath}/api/BroadcastConnectionConfigurationView/${encodeURIComponent(String(broadcastConnectionConfigurationId))}/certificate`,
            {
                // @ts-ignore
                responseType:'blob',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param broadcastConnectionConfigurationId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCountryBroadcastConnectionConfigurationLogo(broadcastConnectionConfigurationId: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getCountryBroadcastConnectionConfigurationLogo(broadcastConnectionConfigurationId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getCountryBroadcastConnectionConfigurationLogo(broadcastConnectionConfigurationId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getCountryBroadcastConnectionConfigurationLogo(broadcastConnectionConfigurationId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (broadcastConnectionConfigurationId === null || broadcastConnectionConfigurationId === undefined) {
            throw new Error('Required parameter broadcastConnectionConfigurationId was null or undefined when calling getCountryBroadcastConnectionConfigurationLogo.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Blob>(`${this.basePath}/api/BroadcastConnectionConfigurationView/${encodeURIComponent(String(broadcastConnectionConfigurationId))}/logo`,
            {
                // @ts-ignore
                responseType:'blob',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/business/{businessId} AmsResource:{country}/{business}/_* 
     * @param businessId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listBusinessBroadcastConnectionConfigurations(businessId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BusinessBroadcastConnectionConfigurationListItemDto>>;
    public listBusinessBroadcastConnectionConfigurations(businessId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BusinessBroadcastConnectionConfigurationListItemDto>>>;
    public listBusinessBroadcastConnectionConfigurations(businessId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BusinessBroadcastConnectionConfigurationListItemDto>>>;
    public listBusinessBroadcastConnectionConfigurations(businessId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (businessId === null || businessId === undefined) {
            throw new Error('Required parameter businessId was null or undefined when calling listBusinessBroadcastConnectionConfigurations.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BusinessBroadcastConnectionConfigurationListItemDto>>(`${this.basePath}/api/BroadcastConnectionConfigurationView/business/${encodeURIComponent(String(businessId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/country/{countryId} AmsResource:{country}/_* 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listCountryBroadcastConnectionConfigurations(countryId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CountryBroadcastConnectionConfigurationListItemDto>>;
    public listCountryBroadcastConnectionConfigurations(countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CountryBroadcastConnectionConfigurationListItemDto>>>;
    public listCountryBroadcastConnectionConfigurations(countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CountryBroadcastConnectionConfigurationListItemDto>>>;
    public listCountryBroadcastConnectionConfigurations(countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling listCountryBroadcastConnectionConfigurations.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CountryBroadcastConnectionConfigurationListItemDto>>(`${this.basePath}/api/BroadcastConnectionConfigurationView/country/${encodeURIComponent(String(countryId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/countryMappings/{countryId} AmsResource:{country}/_* 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listCountryBroadcastConnectionConfigurationsMappings(countryId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CountryBroadcastConnectionConfigurationMappingsListItemDto>>;
    public listCountryBroadcastConnectionConfigurationsMappings(countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CountryBroadcastConnectionConfigurationMappingsListItemDto>>>;
    public listCountryBroadcastConnectionConfigurationsMappings(countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CountryBroadcastConnectionConfigurationMappingsListItemDto>>>;
    public listCountryBroadcastConnectionConfigurationsMappings(countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling listCountryBroadcastConnectionConfigurationsMappings.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CountryBroadcastConnectionConfigurationMappingsListItemDto>>(`${this.basePath}/api/BroadcastConnectionConfigurationView/countryMappings/${encodeURIComponent(String(countryId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/{broadcastConnectionConfigurationId}/business/{businessId} AmsResource:{country}/{business}/_* 
     * @param broadcastConnectionConfigurationId 
     * @param businessId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listCountryBroadcastConnectionConfigurations_1(broadcastConnectionConfigurationId: string, businessId: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessBroadcastConnectionConfigurationDto>;
    public listCountryBroadcastConnectionConfigurations_1(broadcastConnectionConfigurationId: string, businessId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessBroadcastConnectionConfigurationDto>>;
    public listCountryBroadcastConnectionConfigurations_1(broadcastConnectionConfigurationId: string, businessId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessBroadcastConnectionConfigurationDto>>;
    public listCountryBroadcastConnectionConfigurations_1(broadcastConnectionConfigurationId: string, businessId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (broadcastConnectionConfigurationId === null || broadcastConnectionConfigurationId === undefined) {
            throw new Error('Required parameter broadcastConnectionConfigurationId was null or undefined when calling listCountryBroadcastConnectionConfigurations_1.');
        }

        if (businessId === null || businessId === undefined) {
            throw new Error('Required parameter businessId was null or undefined when calling listCountryBroadcastConnectionConfigurations_1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessBroadcastConnectionConfigurationDto>(`${this.basePath}/api/BroadcastConnectionConfigurationView/${encodeURIComponent(String(broadcastConnectionConfigurationId))}/business/${encodeURIComponent(String(businessId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BroadcastConnectionConfigurationView/MobileMakesAndModels AmsResource:{country}/_* 
     * @param market 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mobileMakesAndModels(market?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MakeAndModelDto>>;
    public mobileMakesAndModels(market?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MakeAndModelDto>>>;
    public mobileMakesAndModels(market?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MakeAndModelDto>>>;
    public mobileMakesAndModels(market?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (market !== undefined && market !== null) {
          queryParameters = queryParameters.set('market', <any>market);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MakeAndModelDto>>(`${this.basePath}/api/BroadcastConnectionConfigurationView/MobileMakesAndModels`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
